import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-property-tax',
  templateUrl: './property-tax.component.html',
  styleUrls: ['./property-tax.component.css']
})
export class PropertyTaxComponent implements OnInit {
  currentUser
  constructor(private router: Router, public userService: UserService,) { }
  async ngOnInit(){
    this.currentUser = await this.userService.getCurrentUser().toPromise()
  }
  onCardClick(card) {
    this.router.navigate([`/${card}`]);
  }
}
